(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-categories"] && !Shopify.designMode) return;
  try {
    
const swiper = new Swiper(".featuredSwiper", {
  slidesPerView: 2,
  spaceBetween: 30,
  navigation: {
    nextEl: ".custom-next",
    prevEl: ".custom-prev",
  },
  on: {
    slideChange: function () {
      const totalSlides = swiper.slides.length;
      const visibleSlides = swiper.params.slidesPerView;

      let progress = ((swiper.activeIndex + visibleSlides) / totalSlides) * 100;

      if (progress > 100) progress = 100;  // Cap

      document.querySelector(".progress-bar-fill").style.width = progress + "%";
    }
  }
});

// Initial progress
const totalSlides = document.querySelectorAll(".featuredSwiper .swiper-slide").length;
const visibleSlides = 2;
document.querySelector(".progress-bar-fill").style.width = (visibleSlides / totalSlides) * 100 + "%";

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Utility helpers
  var $ = function(sel, ctx){ return (ctx || document).querySelector(sel); };
  var $$ = function(sel, ctx){ return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  // Elements
  var accountBtn = $('#chAccountBtn');
  var accountMenu = $('#chAccountMenu');
  var chCatBtn = $('#chCatBtn');
  var chCatMenu = $('#chCatMenu');
  var hamburger = $('#chHamburger');
  var drawer = $('#chMobileDrawer');
  var drawerClose = $('#chDrawerClose');
  var drawerBackdrop = $('#chDrawerBackdrop');
  var mainMenu = $('#chMainMenu');

  // Safe toggles with ARIA
  function setMenuVisibility(btn, menu, visible){
    if(!btn || !menu) return;
    btn.setAttribute('aria-expanded', String(visible));
    menu.style.display = visible ? 'block' : 'none';
    menu.setAttribute('aria-hidden', String(!visible));
  }

  // Account dropdown
  if (accountBtn && accountMenu) {
    setMenuVisibility(accountBtn, accountMenu, false);
    accountBtn.addEventListener('click', function(e){
      e.stopPropagation();
      var isOpen = accountBtn.getAttribute('aria-expanded') === 'true';
      setMenuVisibility(accountBtn, accountMenu, !isOpen);
    });
  }

  // Category dropdown
  if (chCatBtn && chCatMenu) {
    chCatBtn.setAttribute('aria-expanded', 'false');
    chCatMenu.setAttribute('aria-hidden', 'true');
    chCatBtn.addEventListener('click', function(e){
      e.stopPropagation();
      var isOpen = chCatBtn.getAttribute('aria-expanded') === 'true';
      chCatBtn.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) {
        chCatMenu.classList.add('show');
        chCatMenu.setAttribute('aria-hidden','false');
      } else {
        chCatMenu.classList.remove('show');
        chCatMenu.setAttribute('aria-hidden','true');
      }
    });
  }

  // Clicking a category item updates the label (and closes)
  $$('.ch-cat-item').forEach(function(item){
    item.addEventListener('click', function(){
      var label = $('#chCatLabel');
      if(label) label.textContent = item.dataset.cat || item.textContent.trim();
      if (chCatMenu) { chCatMenu.classList.remove('show'); chCatMenu.setAttribute('aria-hidden','true'); }
      if (chCatBtn) chCatBtn.setAttribute('aria-expanded','false');
    });
  });

  // Determine if device supports hover (desktop)
  var isHoverCapable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // Enhance desktop submenu behavior and keep touch click behavior for touch devices
  var menuLinks = $$('.ch-menu-link[data-toggle-submenu]');
  menuLinks.forEach(function(link, idx){
    var item = link.parentElement;
    var submenu = item.querySelector('.ch-submenu');

    // Ensure ARIA
    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');
    if (submenu) {
      submenu.setAttribute('aria-hidden', 'true');
      submenu.id = submenu.id || 'ch-submenu-' + idx;
      link.setAttribute('aria-controls', submenu.id);
    }

    if (isHoverCapable) {
      // On hover-capable devices: use mouseenter/mouseleave and focus for keyboard accessibility
      item.addEventListener('mouseenter', function(){
        item.classList.add('open');
        link.setAttribute('aria-expanded', 'true');
        if (submenu) submenu.setAttribute('aria-hidden', 'false');
      });
      item.addEventListener('mouseleave', function(){
        item.classList.remove('open');
        link.setAttribute('aria-expanded', 'false');
        if (submenu) submenu.setAttribute('aria-hidden', 'true');
      });

      // Keyboard support: open on focus, close when focus leaves
      link.addEventListener('focus', function(){
        item.classList.add('open');
        link.setAttribute('aria-expanded', 'true');
        if (submenu) submenu.setAttribute('aria-hidden', 'false');
      });
      // handle focusout for the whole item (so tabbing into submenu still stays open)
      item.addEventListener('focusout', function(e){
        // if the newly focused element is still inside the item, keep open
        var next = e.relatedTarget;
        if (!next || !item.contains(next)) {
          item.classList.remove('open');
          link.setAttribute('aria-expanded', 'false');
          if (submenu) submenu.setAttribute('aria-hidden', 'true');
        }
      });
    } else {
      // On touch devices: keep click-to-toggle behavior
      link.addEventListener('click', function(e){
        // prevent navigating away so user can open submenu
        e.preventDefault();
        e.stopPropagation();
        var isOpen = item.classList.contains('open');
        // close other open items
        $$('.ch-menu-item.open').forEach(function(openItem){
          if(openItem !== item) {
            openItem.classList.remove('open');
            var openLink = openItem.querySelector('.ch-menu-link[data-toggle-submenu]');
            if (openLink) openLink.setAttribute('aria-expanded','false');
            var openSub = openItem.querySelector('.ch-submenu');
            if (openSub) openSub.setAttribute('aria-hidden','true');
          }
        });
        if (!isOpen) {
          item.classList.add('open');
          link.setAttribute('aria-expanded','true');
          if (submenu) submenu.setAttribute('aria-hidden','false');
        } else {
          item.classList.remove('open');
          link.setAttribute('aria-expanded','false');
          if (submenu) submenu.setAttribute('aria-hidden','true');
        }
      });
    }
  });

  // Mobile drawer open/close helpers
  function openDrawer(){
    if(!drawer) return;
    drawer.setAttribute('aria-hidden','false');
    drawer.style.display = 'block';
    hamburger && hamburger.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
    // focus the first focusable element in drawer (close button)
    setTimeout(function(){
      if(drawerClose) drawerClose.focus();
    }, 50);
  }
  function closeDrawer(){
    if(!drawer) return;
    drawer.setAttribute('aria-hidden','true');
    drawer.style.display = 'none';
    hamburger && hamburger.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
    // return focus to hamburger
    setTimeout(function(){
      if(hamburger) hamburger.focus();
    }, 50);
  }

  if (hamburger && drawer) {
    // ensure drawer initial state
    drawer.setAttribute('aria-hidden','true');
    drawer.style.display = 'none';

    hamburger.addEventListener('click', function(e){
      e.stopPropagation();
      var isOpen = drawer.getAttribute('aria-hidden') === 'false';
      if(isOpen) closeDrawer(); else openDrawer();
    });
  }

  if (drawerClose) drawerClose.addEventListener('click', function(e){
    e.stopPropagation();
    closeDrawer();
  });

  if (drawerBackdrop) drawerBackdrop.addEventListener('click', function(e){
    closeDrawer();
  });

  // Close menus on global click (except when clicking inside menus)
  document.addEventListener('click', function(e){
    if (accountMenu && !e.target.closest('#chAccount')) {
      setMenuVisibility(accountBtn, accountMenu, false);
    }
    if (chCatMenu && !e.target.closest('.ch-cat')) {
      if (chCatMenu.classList.contains('show')) {
        chCatMenu.classList.remove('show');
        chCatMenu.setAttribute('aria-hidden','true');
        chCatBtn && chCatBtn.setAttribute('aria-expanded','false');
      }
    }

    // Close desktop open submenus when clicking outside the main nav
    if (mainMenu && !e.target.closest('#chMainMenu')) {
      $$('.ch-menu-item.open').forEach(function(openItem){
        openItem.classList.remove('open');
        var openLink = openItem.querySelector('.ch-menu-link[data-toggle-submenu]');
        if (openLink) openLink.setAttribute('aria-expanded','false');
        var openSub = openItem.querySelector('.ch-submenu');
        if (openSub) openSub.setAttribute('aria-hidden','true');
      });
    }
  });

  // Keyboard handling (Esc closes drawers/menus)
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' || e.key === 'Esc') {
      // account menu
      setMenuVisibility(accountBtn, accountMenu, false);
      // category menu
      if (chCatMenu) {
        chCatMenu.classList.remove('show');
        chCatMenu.setAttribute('aria-hidden','true');
        chCatBtn && chCatBtn.setAttribute('aria-expanded','false');
      }
      // drawer
      closeDrawer();
      // collapse any mobile submenus
      $$('.mobile-submenu.show').forEach(function(sm){ sm.classList.remove('show'); sm.setAttribute('aria-hidden','true'); });
      $$('.mobile-submenu-toggle').forEach(function(btn){ btn.setAttribute('aria-expanded','false'); });

      // close top-level open menu items
      $$('.ch-menu-item.open').forEach(function(openItem){
        openItem.classList.remove('open');
        var ol = openItem.querySelector('.ch-menu-link[data-toggle-submenu]');
        if (ol) ol.setAttribute('aria-expanded','false');
        var os = openItem.querySelector('.ch-submenu');
        if (os) os.setAttribute('aria-hidden','true');
      });
    }
  });

  // Mobile submenu toggles inside the drawer
  $$('.mobile-submenu-toggle').forEach(function(btn){
    var targetId = btn.getAttribute('aria-controls');
    var submenu = targetId ? document.getElementById(targetId) : null;
    if (submenu) {
      submenu.setAttribute('aria-hidden','true');
      btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        if(!isOpen){
          submenu.classList.add('show');
          submenu.setAttribute('aria-hidden','false');
        } else {
          submenu.classList.remove('show');
          submenu.setAttribute('aria-hidden','true');
        }
      });
    }
  });

  // Make product/cart count refresh target correct
  function refreshCartCount() {
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(data){
      var els = $$('.cart-count');
      els.forEach(function(el){
        el.textContent = data.item_count || 0;
      });
    }).catch(function(){});
  }
  // run once (best-effort)
  if (window.fetch) { refreshCartCount(); }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
